<template>
  <div id="svg-icon" :class="'is-txt-'+color">
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M23 6.00013C23 6.00004 23
    6 24 6H24.1761C24.2533 6 24.3233 6 24.3868 6C25 6.00001 25 6.00005 25
    6.00013V20.5C25 21.8977 25.5641 22.4421 26.0039 22.6987C26.053 22.7273
    26.1024 22.7533 26.1516 22.777C26.1506 22.6568 26.1493 22.5316 26.1479
    22.4019L26.1479 22.4003C26.1101 18.8716 26.0365 11.9997 31.4753
    11.9997C38.9259 11.9997 44.2478 38.0062 41.0547 40.6599C37.8615 43.3136
    31.4753 41.7214 28.2822 38.5369C25.7042 35.9659 25.9272 29.9583 26.0873
    25.6457L26.0874 25.6443C26.0971 25.3819 26.1067 25.1258 26.1153
    24.8771C25.79 24.7962 25.3959 24.6595 24.9962 24.4263C24.6398 24.2184
    24.2975 23.9442 24 23.5919C23.7026 23.9442 23.3603 24.2184 23.0039
    24.4263C22.6041 24.6595 22.2101 24.7962 21.8848 24.8771C21.8934 25.1261
    21.9029 25.3826 21.9127 25.6453C22.0728 29.9579 22.2959 35.9662 19.7179
    38.5372C16.5247 41.7217 10.1385 43.3139 6.94536 40.6602C3.75222 38.0065
    9.07413 12 16.5247 12C21.9636 12 21.89 18.8717 21.8522 22.4003C21.852
    22.4166 21.8518 22.4328 21.8516 22.4489C21.8504 22.5619 21.8493 22.6714
    21.8484 22.777C21.8977 22.7534 21.9471 22.7274 21.9962 22.6987C22.436
    22.4421 23 21.8977 23 20.5V6.00013ZM31.4753 13.9997C30.5212 13.9997 29.9843
    14.3002 29.6086 14.6869C29.1752 15.1331 28.8132 15.8507 28.559
    16.8646C28.1141 18.6395 28.133 20.6819 28.1483 22.3293C28.1509 22.6142
    28.1534 22.8874 28.1534 23.1453C28.1534 23.9053 28.1196 24.8153 28.0845
    25.7621C28.0707 26.1349 28.0566 26.5133 28.0443 26.8905C27.9996 28.2657
    27.9741 29.7055 28.0405 31.0982C28.1072 32.4985 28.2642 33.7835 28.5573
    34.8596C28.8538 35.9483 29.2509 36.6784 29.6944 37.1208C30.9726 38.3954
    32.9908 39.4251 35.0492 39.8243C37.0842 40.2189 38.7224 39.9269 39.6818
    39.1969C39.6868 39.1857 39.6923 39.1726 39.6984 39.1574C39.7576 39.0095
    39.8294 38.7554 39.8878 38.3683C40.0047 37.5933 40.035 36.5122 39.9562
    35.1803C39.7995 32.5305 39.2286 29.1689 38.3268 25.8606C37.4216 22.5396
    36.2173 19.3998 34.8521 17.1383C34.1688 16.0062 33.4951 15.1786 32.8703
    14.6535C32.2518 14.1337 31.7935 13.9997 31.4753 13.9997ZM16.5247 14C17.4788
    14 18.0158 14.3005 18.3914 14.6872C18.8248 15.1334 19.1868 15.851 19.441
    16.8649C19.8859 18.6399 19.867 20.6822 19.8518 22.3296C19.8491 22.6146
    19.8466 22.8877 19.8466 23.1456C19.8466 23.9056 19.8804 24.8156 19.9155
    25.7624C19.9294 26.135 19.9434 26.5138 19.9557 26.8908C20.0005 28.266
    20.0259 29.7058 19.9596 31.0985C19.8929 32.4988 19.7359 33.7838 19.4427
    34.8599C19.1462 35.9486 18.7492 36.6787 18.3056 37.1211C17.0275 38.3957
    15.0093 39.4254 12.9509 39.8246C10.9159 40.2192 9.27768 39.9272 8.31823
    39.1972C8.31326 39.186 8.3077 39.1729 8.30162 39.1577C8.24241 39.0098
    8.17061 38.7557 8.11224 38.3686C7.99539 37.5936 7.965 36.5125 8.0438
    35.1806C8.20056 32.5308 8.77147 29.1692 9.67324 25.8609C10.5785 22.5399
    11.7827 19.4001 13.1479 17.1386C13.8313 16.0065 14.5049 15.1789 15.1298
    14.6538C15.7482 14.134 16.2065 14 16.5247 14Z" fill="#FFFFFF"/>
    </svg>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        color: String,
        size: String
    }
})
</script>
